var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2386 20.2759C10.7059 20.7427 11.3395 21.0047 12 21.0042C12.6605 21.0044 13.2941 20.7422 13.7613 20.2752C14.2285 19.8082 14.491 19.1747 14.491 18.5141V18.0029",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.24609C8.27073 2.24609 5.24754 5.26929 5.24754 8.99859V12.7375L4.10283 13.8813L4.10208 13.8821C3.5549 14.4304 3.24732 15.1732 3.2467 15.9479L3.9967 15.9485H3.2467C3.2467 16.6921 3.54211 17.4053 4.06793 17.9311C4.59376 18.4569 5.30693 18.7523 6.05056 18.7523H17.9495C19.498 18.7523 20.7534 17.497 20.7534 15.9485H20.0034L20.7534 15.9479C20.7528 15.1732 20.4452 14.4304 19.898 13.8821L19.8972 13.8813L18.7525 12.7375V8.99859C18.7525 5.26929 15.7293 2.24609 12 2.24609ZM5.12859 16.8705C4.88414 16.626 4.74678 16.2945 4.7467 15.9488L19.2534 15.9491C19.253 16.6689 18.6694 17.2523 17.9495 17.2523H6.05056C5.70476 17.2523 5.37312 17.115 5.12859 16.8705ZM4.7467 15.9488L19.2534 15.949C19.253 15.5713 19.1031 15.2092 18.8364 14.9418L18.8362 14.9416L17.4724 13.5788C17.3316 13.4381 17.2525 13.2473 17.2525 13.0483V8.99859C17.2525 6.09772 14.9009 3.74609 12 3.74609C9.09916 3.74609 6.74754 6.09772 6.74754 8.99859V13.0483C6.74754 13.2473 6.66844 13.4381 6.52767 13.5788L5.16386 14.9416L5.16371 14.9418C4.89702 15.2091 4.74709 15.5712 4.7467 15.9488Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.a660e58d383f82a8390d1cbc59a546b2.svg";
export { ForwardRef as ReactComponent };